import { useEffect, useMemo } from 'react';
import echoDefault from 'src/images/svgs/echo/echo-self-like-default.svg';
import echoShock from 'src/images/svgs/echo/echo-self-like-shock.svg';
import echoWink from 'src/images/svgs/echo/echo-self-like-wink.svg';
import { COPY_VARIATIONS, EGG_TIMINGS, STORAGE_KEYS } from './self-like-easter-egg.constants';
import { DefaultEchoImg, EchoWrapper, TooltipContainer, TooltipMessage, VariantEchoImg } from './self-like-easter-egg.styles';
import type { SelfLikeEasterEggProps } from './self-like-easter-egg.types';
import { getNextCopyIndex, getNextVariant } from './self-like-easter-egg.utils';
export const SelfLikeEasterEgg: React.FC<SelfLikeEasterEggProps> = ({
  onComplete
}) => {
  const variantName = useMemo<'wink' | 'shock'>(() => getNextVariant(null), []);
  const variantSrc = variantName === 'wink' ? echoWink : echoShock;
  const copyIndex = useMemo(() => getNextCopyIndex(null), []);
  const copy = COPY_VARIATIONS[copyIndex];
  useEffect(() => {
    try {
      if (typeof window !== 'undefined') window.sessionStorage.setItem(STORAGE_KEYS.lastVariant, variantName);
    } catch {}
  }, [variantName]);
  useEffect(() => {
    const total = EGG_TIMINGS.slideUpMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.variantHoldMs + EGG_TIMINGS.crossfadeMs + EGG_TIMINGS.defaultHoldMs + EGG_TIMINGS.slideDownMs;
    const timer = setTimeout(() => onComplete(), total);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <EchoWrapper aria-hidden="true" data-sentry-element="EchoWrapper" data-sentry-component="SelfLikeEasterEgg" data-sentry-source-file="self-like-easter-egg.tsx">
      <DefaultEchoImg src={echoDefault} alt="Default Echo" data-sentry-element="DefaultEchoImg" data-sentry-source-file="self-like-easter-egg.tsx" />
      <VariantEchoImg src={variantSrc} alt="Echo Wink or Echo Shock" data-sentry-element="VariantEchoImg" data-sentry-source-file="self-like-easter-egg.tsx" />
      <TooltipContainer data-sentry-element="TooltipContainer" data-sentry-source-file="self-like-easter-egg.tsx">
        <TooltipMessage data-sentry-element="TooltipMessage" data-sentry-source-file="self-like-easter-egg.tsx">{copy}</TooltipMessage>
      </TooltipContainer>
    </EchoWrapper>;
};